export enum CatalogItemsDataRouting {
  CatalogItems = '',
  Map = 'map',
  Passport = 'passport',
  Description = 'description'
}
